import React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const PaginationComponent = ({ count, page, onPageChange }) => {
  return (
    <Stack
      spacing={2}
      style={{ float: 'right', marginRight: '1rem', marginTop: '1rem' }}
    >
      <Pagination
        count={count}
        variant="outlined"
        shape="rounded"
        page={page}
        onChange={onPageChange}
      />
    </Stack>
  );
};

export default PaginationComponent;
